<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <ContentsList></ContentsList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Contents",
  data: () => ({
    page: {
      title: "Contents"
    },
    elementVisible: false,
    breadcrumbs: [
      {
        text: "Contents",
        disabled: true
      }
    ]
  }),
  components: {
    ContentsList: () => import("../components/ContentsList")
  }
};
</script>
